export default function EmptyState ({ children }) {
  return (
    <div className='flex flex-col items-center justify-center gap-4 text-center h-72'>
      {children}
    </div>
  )
}
